; (function () {
	"use strict";
	function FurtherLinksSlider() {
		var fn = {
			init: function () {
				fn.initSliders();
			},

			initSliders: function() {
				jQuery('.further-links .splide').each(function(index, element) {
					fn.initSlider(element);
				})
			},

			initSlider: function (element) {
				let splide = new Splide(element, {
					perPage: 1,
					fixedWidth: '270px',
					perMove: 1,
					gap: '0',
					type: 'slide',
					pagination: false,
					arrows: false,
					mediaQuery: 'min',
					breakpoints: {
						750: {
						  destroy: true,
						},
						560: {
						  perPage: 2,
						},
						320: {}
					}
				}).mount();

				let prevButton = element.querySelector('.further-links__nav-button--prev');
				let nextButton = element.querySelector('.further-links__nav-button--next');

				// Add event listeners
				prevButton.addEventListener('click', function () {
					splide.go('<'); // Move to the previous slide
				});
				nextButton.addEventListener('click', function () {
					splide.go('>'); // Move to the next slide
				});
			},
		}
		jQuery(document).ready(fn.init);
	}
	new FurtherLinksSlider();
})();